import * as jQuery from 'jquery';
import 'jquery-colorbox';

const NewsletterSignup = () => {
	jQuery('a[href="newsletter-signup.html"]').colorbox({
		transition: 'none',
		maxWidth: '80%',
		maxHeight: '80%',
		width: 460,
		height: 400,
		initialWidth: 460,
		initialHeight: 400,
		fixed: true,
		close: '<span>Close</span>',
		className: 'colorbox',
		href: function(){
			return jQuery(this).attr('href') + ' #newsletterSignup';
		},
		onComplete: function(){
			jQuery.colorbox.resize();
			const script = document.createElement('script');
			script.setAttribute('type', 'text/javascript');
			script.setAttribute('src', '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js');
			document.body.appendChild(script);
			const script2 = document.createElement('script');
			script2.setAttribute('type', 'text/javascript');
			script2.appendChild(document.createTextNode("(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';}(jQuery));var $mcj = jQuery.noConflict(true);"));
			document.body.appendChild(script2);

			window.setInterval(function(){
				jQuery.colorbox.resize();
			}, 500);
		}
	});
};

export default NewsletterSignup;
